// carrierMapper.js
export function getCarrierDisplayName(carrierName, trackingNumber = "") {
    if (!carrierName) return "";

    switch (carrierName) {
        case "LME_WORLD":
            return String(trackingNumber).startsWith("1Z") ? "UPS" : "LME_WORLD";
        case "LME_WORLD_UNI":
            return "UNIEXPRESS";
        case "LME_WORLD_PUROLATOR":
            return "PUROLATOR";
        case "LME_WORLD_EMILE":
            return "EMILE";
        case "LME_WORLD_UPS":
            return "UPS";
        default:
            return carrierName;
    }
}
